module.exports = __webpack_public_path__ + "img/overnight-parking.47ebc961.svg";